import { resource, tapEffect, tapInlineResource } from "@assistant-ui/tap";
import { ThreadListClient } from "./client/ThreadListRuntimeClient.js";
import { tapAssistantClientRef, Derived, attachDefaultPeers, } from "@assistant-ui/store";
import { ModelContext } from "../client/ModelContextClient.js";
import { Tools, Suggestions } from "../model-context/index.js";
export const RuntimeAdapter = resource((runtime) => {
    const clientRef = tapAssistantClientRef();
    tapEffect(() => {
        return runtime.registerModelContextProvider(clientRef.current.modelContext());
    }, [runtime, clientRef]);
    return tapInlineResource(ThreadListClient({
        runtime: runtime.threads,
        __internal_assistantRuntime: runtime,
    }));
});
attachDefaultPeers(RuntimeAdapter, {
    modelContext: ModelContext(),
    tools: Tools({}),
    suggestions: Suggestions(),
    threadListItem: Derived({
        source: "threads",
        query: { type: "main" },
        get: (aui) => aui.threads().item("main"),
    }),
    thread: Derived({
        source: "threads",
        query: { type: "main" },
        get: (aui) => aui.threads().thread("main"),
    }),
    composer: Derived({
        source: "thread",
        query: {},
        get: (aui) => aui.threads().thread("main").composer,
    }),
});
//# sourceMappingURL=RuntimeAdapter.js.map